import { Component } from '@angular/core';
import { CartAndCheckoutLoadingService } from '@shared/services/cart-and-checkout-loading.service';
import { LaunchDialogService, IconComponent } from '@spartacus/storefront';
import { CUSTOM_LAUNCH_CALLER } from '../../../launch-caller/launch-caller-enum.model';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-cart-delete',
    templateUrl: './cart-delete.component.html',
    imports: [NgbDropdownButtonItem, NgbDropdownItem, IconComponent, TranslatePipe]
})
export class CartDeleteComponent {

  constructor(private cartAndCheckoutLoadingService: CartAndCheckoutLoadingService,
    private launchDialogService: LaunchDialogService) {
  }

  openDeleteDialog(): void {
    this.launchDialogService.openDialogAndSubscribe(CUSTOM_LAUNCH_CALLER.CART_DELETE, undefined, undefined);
    this.launchDialogService.dialogClose.subscribe(result => {
      if (result === 'deleted') {
        setTimeout(() => {this.cartAndCheckoutLoadingService.setCartDeleting(false);
                          this.cartAndCheckoutLoadingService.setCartItemListLoading(false); }, 2000);
      }
    });
  }

}
